//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import MatrixView from "./MatrixView.vue";
import ExclusionView from "./ExclusionView.vue";
export default {
    components: { MatrixView, ExclusionView },
    props: {
        objectProp: {
            type: Object,
            required: true,
        },
        isAdmin: {
            type: Boolean,
            required: true,
        },
    },
    created() {
        BackendServices.getFieldList().then(({ data }) => {
            this.fields = data;
        });
    },
    beforeMount() {
        this.activeObject = Object.assign({}, this.objectProp);
    },
    mounted() {
        BackendServices.getFileUploadDataTypes().then(({ data }) => {
            this.uploadDataTypeList = data;
        });
        BackendServices.getStoreHierarchyLevels().then(({ data }) => {
            this.retailerLevelList = data;
        });
        BackendServices.getDateFormatList().then(({ data }) => {
            this.dateFormatList = data;
        });
        BackendServices.getFileUploadTypeList().then(({ data }) => {
            this.fileTypeList = data;
        });
        BackendServices.getFileUploadMappingFrequencies().then(({ data }) => {
            this.mappingFrequecies = data;
        });

    },
    data() {
        return {
            uploadDataTypeList: [],
            retailerLevelList: [],
            dateFormatList: [],
            fileTypeList: [],
            mappingFrequecies: [],
            activeObject: null,
            fields: [],
        }
    },
    methods: {
        updateData() {
            this.$emit("update", this.activeObject);
        },
        closeForm() {
            this.$emit("close");
        },

    },
    computed: {
        displayText() {
            if (this.activeObject == null) {
                return "Selecione um mapeamento";
            }

            if (this.activeObject.disabled) {
                return `${this.activeObject.name} (Desativado)`;
            } else {
                let elementName = this.activeObject.frequency
                if (elementName == "daily") {
                    elementName = "Diário";
                } else if (elementName == "weekly") {
                    elementName = "Semanal";
                } else if (elementName == "monthly") {
                    elementName = "Mensal";
                } else if (elementName == null) {
                    elementName = "";
                }
                return `${this.activeObject.name} ${elementName}`;
            }
        }
    },
    watch: {
        objectProp: function (newVal) {
            this.activeObject = newVal;
        }
    },
}

